import {getAppConfigVar} from '../config';
import {showModal} from './modal';
import autocomplete, {AutocompleteItem, PreventSubmit} from "autocompleter";
import {WateringAdviceSignUpResponse} from '../../types/WateringAdviceSignUpResponse';
import ApiSubscriberFormResponse from '../../types/ApiSubscriberFormResponse';
import Cookies from 'js-cookie'
import PromoCodeInfo from '../../types/PromoCodeInfo';


/**
 *
 */
const subscriberFormPath       = '/api/subscribers/get-form/';
const subscriberFormSubmitPath = '/api/subscribers/add/';
let wateringAdviceApiUrl       = null;


/**
 *
 */
const setupWeeklyWateringAdviceSubscribe = () =>
{
	const links = document.querySelectorAll( 'a[href="#advice-signup-form-container"]' );

	if (!links.length) {
		return;
	}

	wateringAdviceApiUrl = getAppConfigVar( 'wateringAdviceApiUrl' );

	getForm().then( ( html ) =>
	{
		/*
		const mainContent = document.querySelector( '.main-content' );

		if (mainContent instanceof HTMLElement) {

			mainContent.insertAdjacentHTML( 'beforeend', `
				<div id="advice-signup-form-container" class="visually-hidden">
					${html}
				</div>
			` );
		}
		 */
		
		links.forEach( link =>
		{
			link.addEventListener( 'click', e =>
			{
				e.preventDefault();
				showFormModal( html );
			} );
		} );
	} );
};


/**
 *
 */
const showFormModal = ( html: string ) =>
{
	showModal( 'weekly-watering-advice-subscribe-modal', '', html, true );

	/*
	const devMode = getAppConfigVar( 'devMode' );

	if (devMode) {
		const maps = {
			'wa-firstName':     'PromoCode',
			'wa-lastName':      'Test1',
			'wa-emailAddress':  'test1@example.com',
			'wa-emailAddress2': 'test1@example.com',
			'wa-address-city':  'Dallas',
			'wa-address-zip':   '75201',
		};

		Object.keys( maps ).forEach( key =>
		{
			const input = document.querySelector( `#${key}` );

			if (input instanceof HTMLInputElement) {
				input.value = maps[key];
			}
		} );
	}

	 */

	// promo codes

	const promoCodeCookie: string | undefined = Cookies.get( 'promoCode' );
	const promoCodeInfo: PromoCodeInfo | null = promoCodeCookie ? JSON.parse( promoCodeCookie ) : null
	const promoCodeInput                      = document.querySelector( '#wa-promoCode' );
	const promoCodeMsgContainer               = document.querySelector( '#wa-promo-code-message' );

	if (promoCodeInfo) {

		if (promoCodeInput instanceof HTMLInputElement) {
			promoCodeInput.value = promoCodeInfo.promo_code;
		}

		if (promoCodeMsgContainer instanceof HTMLElement) {
			promoCodeMsgContainer.innerHTML = promoCodeInfo.description_for_subscribers;
			promoCodeMsgContainer.classList.remove( 'hidden' );
		}
	}

	// city autocomplete

	const cityInput   = document.querySelector( '#wa-address-city' );
	const cityOptions = document.querySelectorAll( '#wa-city-list option' );
	const cities      = [...cityOptions].map( option =>
	{
		return {
			label: option instanceof HTMLOptionElement ? option.value : '',
		};
	} );

	if (cityInput instanceof HTMLInputElement && cities.length) {

		autocomplete( {
			input:         cityInput,
			minLength:     1,
			preventSubmit: PreventSubmit.Always,
			fetch:         ( text, update ) =>
						   {
							   const suggestions = cities.filter( ( n ) =>
								   n.label.toLowerCase().startsWith( text.toLowerCase() )
							   );

							   update( suggestions );
						   },
			onSelect:      ( item: AutocompleteItem ) =>
						   {
							   if (item.label) {
								   cityInput.value = item.label;
							   }
						   },
		} );
	}

	// form submit

	const form = document.querySelector( '#wa-subscribe-form' );

	if (form instanceof HTMLFormElement) {

		form.addEventListener( 'submit', ( e ) =>
		{
			e.preventDefault();

			handleSubmit()
				.then( () => null )
				.catch( () => null );
		} );
	}
};


const handleSubmit = (): Promise<void> =>
{
	return new Promise( ( resolve, reject ) =>
	{
		const form = document.querySelector( '#wa-subscribe-form' );

		if (!wateringAdviceApiUrl || !(form instanceof HTMLFormElement)) {
			reject();
			return;
		}

		const url                  = wateringAdviceApiUrl + subscriberFormSubmitPath;
		const formData             = new FormData( form );
		const msgElem              = document.querySelector( '#wa-msg' );
		const allElems             = document.querySelectorAll( '#wa-subscribe-form *' );
		const errorElems           = document.querySelectorAll( '#wa-subscribe-form .wa-error' );
		const submitBtn            = document.querySelector( '#wa-submitButton' );
		const options: RequestInit = {
			method: 'post',
			mode:   'cors',
			cache:  'no-cache',
			body:   formData,
		};

		if (msgElem instanceof HTMLElement) {
			msgElem.innerHTML = '';
			msgElem.classList.remove( 'error' );
			msgElem.classList.add( 'hidden' );
		}

		allElems.forEach( elem => elem.classList.remove( 'error' ) );
		errorElems.forEach( elem => elem.remove() );

		if (submitBtn instanceof HTMLElement) {
			submitBtn.setAttribute( 'disabled', 'disabled' );
		}

		fetch( url, options )
			.then( response => response.json() )
			.then( ( response: WateringAdviceSignUpResponse ) =>
			{
				const scrollToFormTop = () =>
				{
					const elem = document.querySelector( '#weekly-watering-advice-subscribe-modal .modal-body' );

					if (elem) {
						elem.scrollTo( {
							top:      0,
							left:     0,
							behavior: 'smooth',
						} );
					}
				};

				if (response.success) {

					if (msgElem instanceof HTMLElement) {
						msgElem.innerHTML = response.msg;
						msgElem.classList.add( 'success' );
						msgElem.classList.remove( 'hidden' );
					}

					if (form) {
						form.classList.add( 'complete' );
					}

					scrollToFormTop();
					resolve();

				} else {

					if (response.errors) {

						response.errors.forEach( err =>
						{
							const formElem    = document.querySelector( `#wa-subscribe-form [name="${err.field}"]` );
							const privacyElem = document.querySelector( '#wa-subscribe-form .privacy' );

							if (formElem) {

								const insertPosition = err.field === 'privacyAgree' ? 'beforebegin' : 'afterend';

								formElem.classList.add( 'error' );
								formElem.insertAdjacentHTML( insertPosition, `<div class="wa-error">${err.msg}</div>` );
							}

							if (err.field === 'privacyAgree' && privacyElem) {
								privacyElem.classList.add( 'error' );
							}
						} );
					}

					if (submitBtn instanceof HTMLElement) {
						submitBtn.removeAttribute( 'disabled' );
					}

					if (msgElem instanceof HTMLElement) {
						msgElem.innerHTML = response.msg;
						msgElem.classList.add( 'error' );
						msgElem.classList.remove( 'hidden' );
					}

					scrollToFormTop();
					reject();
				}
			} );
	} );
};


/**
 *
 */
const getForm = (): Promise<string> =>
{
	return new Promise( ( resolve, reject ) =>
	{
		if (!wateringAdviceApiUrl) {
			reject();
			return;
		}

		const url = wateringAdviceApiUrl + subscriberFormPath + '?template=bs5';

		fetch( url )
			.then( response => response.json() )
			.then( ( response: ApiSubscriberFormResponse ) =>
			{
				if (response.success) {
					resolve( response.html );
				} else {
					reject();
				}
			} );
	} );
};


/**
 *
 */
export default setupWeeklyWateringAdviceSubscribe;